<template>
  <div class="header pt-20 pb-20">
      
    <span class="fs-28 ml-10 lh-40" style="color:#fff">振农学堂在线培训管理</span>
    <div style="float:right" v-if="$route.path.includes('lesson')">
      <!-- <span class="c-f mr-10">2022年10月14日(星期五)22:00，本系统将进行停机维护，预计时间30分钟，期间无法正常使用，不便之处敬请见谅。</span> -->
      <el-button size="small" @click="topicStoreState = true" >题库</el-button>
      <el-popover
        placement="bottom"
        width="200"
        trigger="click">
        <div >
          <img class="d-b m-auto w-200" src="https://caichendaizhang.oss-cn-shenzhen.aliyuncs.com/miniStudyPlatform/mpCode.jpg" alt="">
          <p class="fs-14 ta-c mt-10">进入小程序，点击底部“客服”按钮，联系客服</p>
        </div>
        <el-button slot="reference" type="success" size="small"> 联系客服</el-button>
      </el-popover>
      <!-- <el-button @click="logout"  class="mr-10" type="primary" size="small">退出登录</el-button> -->
      <el-dropdown class="ml-10 mr-20" @command="dropdownChange">
        <span class="el-dropdown-link">
          <i class="el-icon-user fs-16 c-f"></i> <i class="el-icon-arrow-down c-f el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="openPwdChangeBox">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog  :close-on-click-modal="false" :visible.sync="topicStoreState" width="90%" top="5vh">
      <topic-store></topic-store>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="pwdBoxState" width="450px">
      <el-form  :model="pwdChangeForm" label-width="auto"> 
        <el-form-item label="当前密码" prop="name">
          <el-input type="password" v-model="pwdChangeForm.oldPassword" placeholder="请输入"  show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="zone">
          <el-input type="password" v-model="pwdChangeForm.newPassword" placeholder="请输入"  show-password />
        </el-form-item>
        <el-form-item label="新密码(确认)" prop="time">
          <el-input type="password" v-model="pwdChangeForm.validate" placeholder="请输入"  show-password />
        </el-form-item>
      </el-form>
      <div class="ta-c">
        <el-button type="primary" @click="confirmPwdChange">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TopicStore from '@/components/TopicStore'
import {
  Req_ChangePwd
} from '@/ajax/account'
import {
  encruption
} from '@/util'
export default {
  data() {
    return {
      topicStoreState: false,
      pwdBoxState: false,
      pwdChangeForm: {
        oldPassword: '',
        newPassword: '',
        validate: '',
      },
    }
  },
  methods: {
    logout() {
      this.$router.replace('/login')
      setTimeout(() => {
        localStorage.removeItem('userId')
      })
    },
    confirmPwdChange() {
      const {oldPassword,newPassword,validate} = this.pwdChangeForm
      for (const key in this.pwdChangeForm) {
        if(!this.pwdChangeForm[key]) {
          return this.$message('请补全表单信息')
        }
      }
      if(newPassword !== validate) {
        return this.$message('新密码两次输入不一致')
      }
      Req_ChangePwd({
        userId: localStorage.getItem('userId'),
        oldPassword: encruption(oldPassword),
        newPassword: encruption(newPassword)
      }).then(res => {
        this.$message.success('密码修改成功')
        this.pwdBoxState= false
      }).catch(err => this.$catchErr(err))

    },
    openPwdChangeBox() {
      this.pwdBoxState = true
    },
    dropdownChange(command) {
      console.log(command)
      this[command]()
    }
  },
  components: {
    TopicStore
    
  }
}
</script>
<style lang="less" scoped>
.header {

  background: #333;
  border-bottom: 2px solid #13c29f;

}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue